import { render, staticRenderFns } from "./SubKategoriZISPopup.vue?vue&type=template&id=3109a3d0&scoped=true"
import script from "./SubKategoriZISPopup.vue?vue&type=script&lang=js"
export * from "./SubKategoriZISPopup.vue?vue&type=script&lang=js"
import style0 from "./SubKategoriZISPopup.vue?vue&type=style&index=0&id=3109a3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109a3d0",
  null
  
)

export default component.exports